export const blogPostWorkflowOutputTypes = {
  title: 'workflow_1_blogbuilder_title',
  outline: 'workflow_2_blogbuilder_outline',
  intro: 'workflow_3_blogbuilder_intro',
  paragraph: 'workflow_4_blogbuilder_h2_to_paragraph',
};
